import { render } from "./CompararSkuModal.vue?vue&type=template&id=a791a8ec&scoped=true"
import script from "./CompararSkuModal.vue?vue&type=script&lang=js"
export * from "./CompararSkuModal.vue?vue&type=script&lang=js"

import "./CompararSkuModal.vue?vue&type=style&index=0&id=a791a8ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a791a8ec"]])

export default __exports__